import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import CyclojetLogo from "../assets/Cyclojet.png";
import { C } from "../styles/theme";
import { useData } from "../context/DataContext";
import { useAuth } from "../context/AuthContext";
import Snack from "../components/common/Snack";
import { ADMIN_TABS, NO_SEARCH_TABS } from "./AdminUI";

export default function AdminLayout() {
  const { db } = useData();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const tab = location.pathname.split("/")[2] || "dashboard";

  const [snack, setSnack] = useState("");
  const [srch, setSrch] = useState("");
  const toast = m => { setSnack(m); setTimeout(() => setSnack(""), 2600); };

  useEffect(() => { setSrch(""); }, [tab]);

  const activeTab = ADMIN_TABS.find(t => t.id === tab);

  const onBack = () => navigate("/");
  const handleLogout = () => { logout(); navigate("/"); };

  return (
    <div className="admin-layout" style={{ display: "flex", minHeight: "100vh", background: "#f1f5f9" }}>
      <div className="admin-sidebar" style={{ width: 210, background: "linear-gradient(180deg,#060f20,#0c1f3f)", display: "flex", flexDirection: "column", flexShrink: 0, boxShadow: "4px 0 20px rgba(0,0,0,.18)" }}>
        <div className="sidebar-logo" style={{ padding: "15px 14px", borderBottom: "1px solid rgba(255,255,255,.07)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0, background: "#fff" }}>
              <img src={db?.settings?.logoUrl || CyclojetLogo} alt="Cyclojet Logo" style={{ width: 32, height: 32, objectFit: "cover" }} onError={e => { e.target.onerror = null; e.target.src = CyclojetLogo; }} />
            </div>
            <div>
              <div className="serif" style={{ color: "#E8C060", fontWeight: 700, fontSize: 14, lineHeight: 1 }}>{db.settings?.brandName || "Cyclojet"}</div>
              <div style={{ color: "rgba(255,255,255,.3)", fontSize: 9.5, marginTop: 1 }}>Admin Panel</div>
            </div>
          </div>
        </div>
        <nav style={{ flex: 1, padding: "10px 7px", overflowY: "auto", display: "flex", flexDirection: "column", gap: 2 }}>
          {ADMIN_TABS.map(t => (
            <div key={t.id} onClick={() => navigate("/admin/" + t.id)} style={{ display: "flex", alignItems: "center", gap: 8, padding: "9px 11px", borderRadius: 8, cursor: "pointer", background: tab === t.id ? "rgba(201,151,42,.12)" : "transparent", color: tab === t.id ? "#E8C060" : "rgba(255,255,255,.52)", fontSize: 13, fontWeight: tab === t.id ? 700 : 400, borderLeft: tab === t.id ? "2px solid rgba(201,151,42,.6)" : "2px solid transparent", transition: "all .15s" }}>
              <span style={{ fontSize: 15 }}>{t.ic}</span><span className="hide-mobile">{t.lb}</span>
            </div>
          ))}
        </nav>
        <div className="sidebar-back" style={{ padding: "10px 9px", borderTop: "1px solid rgba(255,255,255,.07)", display: "flex", flexDirection: "column", gap: 6 }}>
          <button onClick={onBack} style={{ background: "rgba(255,255,255,.07)", border: "1px solid rgba(255,255,255,.1)", color: "rgba(255,255,255,.6)", padding: "8px 10px", borderRadius: 7, fontSize: 12, cursor: "pointer", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>← Website</button>
          <button onClick={handleLogout} style={{ background: "rgba(232,89,60,.12)", border: "1px solid rgba(232,89,60,.25)", color: "#F2A623", padding: "8px 10px", borderRadius: 7, fontSize: 12, cursor: "pointer", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>Logout</button>
        </div>
      </div>

      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        <div style={{ background: "#fff", borderBottom: "1px solid #e2e8f0", padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, boxShadow: "0 1px 8px rgba(0,0,0,.06)", position: "sticky", top: 0, zIndex: 10 }}>
          <h1 className="serif" style={{ fontSize: 17, fontWeight: 800, color: C.blue, margin: 0 }}>{activeTab?.ic} {activeTab?.lb}</h1>
          {!NO_SEARCH_TABS.includes(tab) && (
            <input value={srch} onChange={e => setSrch(e.target.value)} placeholder={"Search " + tab + "..."} style={{ padding: "7px 13px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13, width: 190, outline: "none", background: "#f8fafc", maxWidth: "100%" }} />
          )}
        </div>

        <div style={{ padding: 18, flex: 1, overflowY: "auto" }}>
          <Outlet context={{ toast, srch }} />
        </div>
      </div>

      <Snack msg={snack} />
    </div>
  );
}
